import React from 'react';
import { View, StyleSheet } from 'react-native';

import { MessageDetailHeader } from '../messageDetailHeader/MessageDetailHeader';
import { MessageDetailText } from '../messageDetailText/MessageDetailText';
import { MessageDetailAttachment } from '../messageDetailAttachment/MessageDetailAttachment';

const styles = StyleSheet.create({
  messageContainer: {
    width: '60vw',
  },
});

const MessageDetail = ({ id, message, isInbox }) => {
  const messageInput = message(id);
  const attachments = messageInput.media.length > 0 ? messageInput.media : null;

  return (
    <View style={styles.messageContainer}>
      <MessageDetailHeader
        deliverAt={messageInput.deliverAt}
        sender={messageInput.sender}
        recipient={messageInput.recipient}
        location={messageInput.location}
        isInbox={isInbox}
      />
      <MessageDetailText text={messageInput.text} />
      {attachments && <MessageDetailAttachment images={attachments} />}
    </View>
  );
};

export default MessageDetail;
